import React from "react";
import "../../cssfiles/homepage.css";
import { Typography } from "@mui/material";

export default function CustomTableMetric({ children }) {
    return (
        <Typography className='emission-config-metric' style={{ fontSize: '14px', fontWeight: 400, color: 'var(--SecondaryText)' }}>
            {children}
        </Typography>
    )
}